/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyLegalAgreementContentResponse
 */
export interface CompanyLegalAgreementContentResponse {
    /**
     * Original HTML content, to sanitize when rendering.
     * @type {string}
     * @memberof CompanyLegalAgreementContentResponse
     */
    content: string;
    /**
     * Current company values keyed by LegalAgreementVariable, with an empty SIGNATURE_DATE since the agreement is not signed yet.
     * @type {{ [key: string]: string; }}
     * @memberof CompanyLegalAgreementContentResponse
     */
    variableValues: { [key: string]: string; };
}

/**
 * Check if a given object implements the CompanyLegalAgreementContentResponse interface.
 */
export function instanceOfCompanyLegalAgreementContentResponse(value: object): value is CompanyLegalAgreementContentResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('variableValues' in value) || value['variableValues'] === undefined) return false;
    return true;
}

export function CompanyLegalAgreementContentResponseFromJSON(json: any): CompanyLegalAgreementContentResponse {
    return CompanyLegalAgreementContentResponseFromJSONTyped(json, false);
}

export function CompanyLegalAgreementContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLegalAgreementContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'variableValues': json['variableValues'],
    };
}

export function CompanyLegalAgreementContentResponseToJSON(value?: CompanyLegalAgreementContentResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
        'variableValues': value['variableValues'],
    };
}

